import React, { useState, useEffect, useCallback } from 'react';
import LoginLayout from 'layout/login-layout';
import { useLocation } from 'react-router-dom';
import LoginForm from './login-form';
import TwoFAForm from './twofa-form';
// import ResetPassword from './reset-password-form';
import OnboardingForm from './onboarding-form';
import ActivationForm from './activation-form';
import { STEPS } from './use-login';
import { Helmet } from 'react-helmet';

const Login = () => {
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState(STEPS.LOGIN);

  useEffect(() => {
    setCurrentStep(location.hash.replace('#', ''));
  }, [location]);

  const Content = useCallback(() => {
    switch (currentStep) {
      case STEPS.TWOFA_LOGIN:
        return <TwoFAForm />;
      case STEPS.ONBOARDING:
        return <OnboardingForm />;
      case STEPS.ACTIVATION:
        return <ActivationForm />;
      default:
        return <LoginForm />;
    }
  }, [currentStep]);

  return (
    <>
      <Helmet>
        <title>企業管理後台｜Autopass for Business</title>
      </Helmet>
      <LoginLayout>
        <Content />
      </LoginLayout>
    </>
  );
};

export default Login;
